import { httpClient } from '@/services/http/httpClient'

export async function deleteUser(id: string): Promise<void> {
  await httpClient.delete(`/users/${id}`)
}
